import React from 'react'

interface Props{
    isInfoOpened: any
    currentInfoText: any,
    currentInfoImg: string,
    handleOpenInfoScreen: any
}

interface State{}

class Info extends React.Component<Props,State>{
    render(): React.ReactNode {
        // console.log(this.props.currentInfoText.map(el => el));
        
        return(
            <div className={this.props.isInfoOpened ? 'info-main-container fade-in':'info-main-container fade-out'}>
                <div className='info-container-bullet'>
                    {
                        this.props.isInfoOpened ?
                        <React.Fragment>
                            {this.props.currentInfoImg ?
                                <div className='img-info-container'>
                                    <img src={this.props.currentInfoImg}/>
                                </div>:null
                            }
                            <div className='text-info-container'>
                                <>
                                
                                    {this.props.currentInfoText.map((text, index) =>  (<p key={index}>{text}</p>))}                       
                                </>
                            </div>
                            <div className='info-close-btn' onClick = {() => {this.props.handleOpenInfoScreen(false, [], [])}}>
                                OK
                            </div>
                        </React.Fragment>:null
                    }
                </div>
            </div>
        )
    }
}

export default Info